import { AudioWavePlayer } from '@/components/AudioWavePlayer';

import { useCallDetail } from '@/context/CallProvider';

import { useCallRecordingQuery } from '@/query/call.query';

export const CallRecording = () => {
  const { call } = useCallDetail();

  const { data: recordingUrl } = useCallRecordingQuery(call.id, {
    enabled: !!call.id,
  });

  return (
    <>
      <div className="text-sm text-foreground font-medium mb-3 flex items-center gap-2">
        <span className="">Recording</span>
      </div>
      <div className="mb-3">
        {recordingUrl !== null ? (
          <AudioWavePlayer
            url={recordingUrl}
            waveColor={'bg-zinc-300 dark:bg-zinc-600'}
            progressColor={'bg-primary'}
          />
        ) : (
          <div className="rounded-lg border border-dashed border-zinc-200 p-4 text-center text-xs text-muted-foreground">
            No recording available
          </div>
        )}
      </div>
    </>
  );
};
